export function setPackages(state, packages) {
  state.packages = packages;
}

export function setPagination(state, { currentPage, perPage, total }) {
  state.pagination = { currentPage, perPage, total };
}

export function setFilters(state, filters) {
  state.filters = { ...state.filters, ...filters };
}

export function resetFilters(state) {
  state.filters = {
    licenseId: null,
    productId: null,
    status: null,
    search: "",
  };
}

export function resetState(state) {
  state.packages = [];
  state.pagination = { currentPage: 1, perPage: 50, total: 0 };
  state.filters = { licenseId: null, productId: null, status: null, search: "" };
  state.selectedKeys = [];
  state.loading = true;
  state.actionLoading = false;
}

export function setSelectedKeys(state, keys) {
  state.selectedKeys = keys;
}

export function togglePackageSelection(state, { licenseId, tag }) {
  const key = `${licenseId}:${tag}`;
  const index = state.selectedKeys.indexOf(key);
  if (index === -1) {
    state.selectedKeys = [...state.selectedKeys, key];
  } else {
    state.selectedKeys = state.selectedKeys.filter((k) => k !== key);
  }
}

export function selectAllPackages(state) {
  state.selectedKeys = state.packages.map(
    (pkg) => `${pkg.license_id}:${pkg.tag}`
  );
}

export function clearSelection(state) {
  state.selectedKeys = [];
}

export function setLoading(state, loading) {
  state.loading = loading;
}

export function setActionLoading(state, loading) {
  state.actionLoading = loading;
}

export function updatePackageExclusionStatus(state, { licenseId, tag, isExcluded }) {
  const pkg = state.packages.find(
    (p) => p.license_id === licenseId && p.tag === tag
  );
  if (pkg) {
    pkg.is_excluded = isExcluded;
  }
}

export function updatePackageCustomMapping(state, { licenseId, tag, customProductId, customProductName }) {
  const pkg = state.packages.find(
    (p) => p.license_id === licenseId && p.tag === tag
  );
  if (pkg) {
    pkg.custom_product_id = customProductId;
    pkg.custom_product_name = customProductName;
  }
}

export function removePackageCustomMapping(state, { licenseId, tag }) {
  const pkg = state.packages.find(
    (p) => p.license_id === licenseId && p.tag === tag
  );
  if (pkg) {
    pkg.custom_product_id = null;
    pkg.custom_product_name = null;
  }
}
